"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const format_url_1 = require("next/dist/shared/lib/router/utils/format-url");
const link_1 = __importDefault(require("next/link"));
const react_1 = __importDefault(require("react"));
const RouterLink = props => {
    const { isExternal = false, children, href = '' } = props, otherProps = __rest(props, ["isExternal", "children", "href"]);
    let { passHref } = otherProps;
    let { as = href } = otherProps;
    if (typeof as === 'object') {
        as = (0, format_url_1.formatUrl)(as);
    }
    // This will return the first child, if multiple are provided it will throw an error
    let child = null;
    try {
        child = react_1.default.Children.only(children);
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error(`RouterLink should contain only or at least one child`);
        // ignore
    }
    const childProps = child ? Object.assign({}, child.props) : {};
    if (isExternal) {
        return child
            ? react_1.default.cloneElement(child, passHref ? { href: as } : {})
            : null;
    }
    if (process.env.NODE_ENV === 'development') {
        href === '' &&
            // eslint-disable-next-line no-console
            console.warn(`You have not passed href property to RouterLink`);
    }
    // It needs to pass href to any child
    // to override next.js passing wrong href with locale prefix
    // when it's not needed
    if (child && !childProps.href && as) {
        passHref = false;
        childProps.href = as;
        child = react_1.default.cloneElement(child, childProps);
    }
    if (!child) {
        child = children;
    }
    // @todo: remove legacyBehavior
    return href ? (react_1.default.createElement(link_1.default, Object.assign({ locale: false }, otherProps, { href: href, as: as, passHref: passHref, legacyBehavior: true }), child)) : (react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.default = RouterLink;
//# sourceMappingURL=RouterLink.js.map